import { FRESHDESK_STATUSES } from '../../../actions/freshdesk-actions';
import PropTypes from 'prop-types';
import { TicketDetails } from './TicketDetails';
import { FormattedMessage } from 'react-intl';
import React from 'react';

export const TicketFooter = ({ ticket, classes }) => {
  const { id, status } = ticket;
  
  const findStatusByCode = (status) => {
    return Object.values(FRESHDESK_STATUSES).find(s => s.code === status) || {
      defaultMessage: 'unknown',
      translationId: 'freshdesk.status.unknown',
    };
  };
  const { defaultMessage, translationId } = findStatusByCode(status);
  
  return (
    <div className={classes.taskStatusWrapper}>
      <p>
        <FormattedMessage id="freshdesk.statusBar.ticket" defaultMessage="Ticket" /> #{id}
      </p>
      <p>
        <FormattedMessage id="freshdesk.statusBar.status" defaultMessage="Status" />
        :&nbsp;
        <FormattedMessage id={translationId} defaultMessage={defaultMessage} />
      </p>
    </div>
  );
};

TicketDetails.propTypes = {
  ticket: PropTypes.string,
  classes: PropTypes.object,
};